import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import Corretor from "../../model/Corretor";
import { useToastContext } from "../../provider/ToastContext";
import CorretorService from "../../service/administracao/CorretorService";

type Props = {
    corretor: Corretor | null;
    visible: boolean;
    onHide: () => void;
    onConfirm: () => void;
};

const corretorService = new CorretorService();

export default function EditarCorretorDialog({ corretor, visible, onHide, onConfirm }: Props) {
    const [email, setEmail] = useState("");
    const { msgErro } = useToastContext();

    useEffect(() => {
        setEmail(corretor?.email ?? "");
    }, [corretor, visible]);

    const salvar = () => {
        if (!corretor || !email.trim()) {
            return;
        }

        corretorService.alterarEmail(corretor.id, email.trim())
            .then(onConfirm)
            .catch((erro) => {
                msgErro("Erro ao atualizar e-mail", erro?.data?.message || "Tente novamente mais tarde.");
            });
    };

    return (
        <Dialog
            header="Editar corretor"
            visible={visible}
            style={{ width: "450px" }}
            onHide={onHide}
            footer={(
                <div>
                    <Button label="Cancelar" outlined onClick={onHide} />
                    <Button label="Salvar" icon="pi pi-check" onClick={salvar} disabled={!email.trim()} />
                </div>
            )}
        >
            <div className="flex flex-column gap-2">
                <label htmlFor="nome-corretor">Corretor</label>
                <InputText id="nome-corretor" value={corretor?.nome ?? ""} disabled />

                <label htmlFor="email-corretor">E-mail</label>
                <InputText id="email-corretor" value={email} onChange={(evento) => setEmail(evento.target.value)} />
            </div>
        </Dialog>
    );
}
